import React, { useEffect, useState } from "react";
import { Flame, Zap, Radio } from "lucide-react";
import { getFeed } from "../lib/api";

const iconFor = (t) => (t === "hot" ? Flame : t === "event" ? Radio : Zap);
const colorFor = (t) => (t === "hot" ? "#FF0055" : t === "event" ? "#00F0FF" : "#FFD600");

export default function NewsTicker() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    let alive = true;
    getFeed().then((p) => {
      if (alive) setPosts((p || []).slice(0, 12));
    }).catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!posts.length) return null;

  return (
    <div data-testid="news-ticker" className="relative overflow-hidden glass rounded-2xl py-2 border-y border-white/5">
      <div className="ticker-track">
        {[...posts, ...posts].map((p, i) => {
          const Icon = iconFor(p.type);
          const c = colorFor(p.type);
          return (
            <div key={`${p.post_id}-${i}`} className="inline-flex items-center gap-2 px-5 text-sm">
              <Icon className="w-4 h-4" style={{ color: c }} />
              <span className="font-semibold text-white/90">{p.title}</span>
              <span className="text-white/40">— {p.content}</span>
              <span className="mx-3 text-white/20">•</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
